import AnnoucementTable from "./AnnoucementTable";

export default function AnnoucementConfig() {
  return (
    <div>
      <AnnoucementTable />
    </div>
  );
}
